import React, { Component } from 'react';
import './App.css';
import Header from './header';
import Footer from './footer';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import LetsGo from './letsGo';
import Home from './home';
import About from './about';
import axios from 'axios';
import Profile from './profile';

class App extends Component {

  constructor(props) {
      super(props);
      this.state = {
        current_user_id: "",
        userName: "",
        password: ""


      }
      this.logout=this.logout.bind(this);
      this.login=this.login.bind(this);
      this.closeModal=this.closeModal.bind(this);
      this.updateUserName=this.updateUserName.bind(this);
      this.updatePassword=this.updatePassword.bind(this);
      this.submitLogin=this.submitLogin.bind(this);
      this.renderLetsGo=this.renderLetsGo.bind(this);
      this.setCurrentUser=this.setCurrentUser.bind(this);

    }

    logout(){
      this.setState({current_user_id: ""})
    }

    closeModal(){
      document.getElementById('login-modal').style.display="none";
      this.setState({userName: "", password: ""});
      document.getElementById("username").value="";
      document.getElementById('password').value="";
      document.body.style.overflow="visible";
    }

    updateUserName(event){
      this.setState({userName: event.target.value})
    }

    updatePassword(event){
      this.setState({password: event.target.value})
    }


    login(){

      document.getElementById('login-modal').style.display="block";
      document.body.style.overflow="hidden";

    }

    submitLogin () {
      var login={userName: this.state.userName, password: this.state.password};
      // axios.post('https://whispering-spire-75342.herokuapp.com/users/login', {
      //         params: {
      //           login
      //         }
      //       })
      //       .then(function (response) {
      //       this.setState({storeStatus: response});
      //       if (response.date==="success"){
      //       this.setState({step: 1, current_user_id: response.id});
      //       console.log(response);}
      //     }.bind(this))
      //       .catch(function (error) {
      //         console.log("server off");
      //         console.log(error);
      //         document.getElementById('createUser').classList.add("serverError");
      //       });
    }

  render() {
    var profile;
    var id=this.state.current_user_id;
    if (id !== ""){
      profile=<Route path="/profile" component={Profile}/>;
    }
    return (
      <BrowserRouter>
      <div>
      <Header
      id={this.state.current_user_id}
      logout={this.logout}
      login={this.login}
       />
        <div className="example-modal" id="login-modal">
          <div className="modal-content">
            <input tabIndex="1" size="35" type="text" id="username" onChange={this.updateUserName} placeholder="User Name"/>
            <input tabIndex="2" size="35" id="password" onChange={this.updatePassword} type="password" placeholder="Password"/>
            <button tabIndex="3" className="login-modal-button" onClick={this.submitLogin}>Login</button>
            <span onClick={this.closeModal} className="modal-closebutton">X</span>
          </div>
        </div>
        <Route path="/letsGo" component={this.renderLetsGo} />
        <Route path="/" exact component={Home} />
        <Route path="/about" component={About} />
        {profile}

      <Footer />


        </div>
      </BrowserRouter>



    );
  }
  renderLetsGo (){
    return (<LetsGo
    current_user_id={this.state.current_user_id}
    setCurrentUser={this.setCurrentUser}
    />)
  }
  setCurrentUser(id){
    this.setState({current_user_id: id})
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js